export const submitPaymentForm = (url, method, inputs) => {
  let form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', url);
  form.setAttribute('target', '_self');

  for (let i = 0; i < inputs.length; i++) {
    let hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', inputs[i].key);
    hiddenField.setAttribute('value', inputs[i].value);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
};
